/* unplugin-vue-components disabled */import { render } from "./topSwiper.vue?vue&type=template&id=057ba188&scoped=true"
import script from "./topSwiper.vue?vue&type=script&lang=js"
export * from "./topSwiper.vue?vue&type=script&lang=js"

import "./topSwiper.vue?vue&type=style&index=0&id=057ba188&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057ba188"]])

export default __exports__